<template>
  <div
    class="min-h-screen relative bg-bgimage bg-cover bg-left flex flex-col items-center justify-center overflow-y-auto no-scrollbar"
  >
    <!-- Background Overlay -->
    <div
      class="absolute inset-0 bg-main-50 dark:bg-gray-900 opacity-90 bg-blend-screen top-0 right-0"
    ></div>

    <!-- Router View with Transition -->
    <router-view v-slot="{ Component }">
      <transition name="slide-fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script>
import { useNetworkToast } from "@/composables/useNetworkStatus";

export default {
  mounted() {
    useNetworkToast();
  },
};
</script>

<style scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition:
    transform 0.5s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.5s ease-in-out;
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
